export default {"src":"/_next/static/media/harmony_native_coin.1ea3cd8c.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};